const Types = {
    USER_LOGOUT: '@auth/USER_LOGOUT',
    USER_UPDATE: '@auth/USER_UPDATE'
}

export default Types;